import { useAtom } from '@reatom/npm-react'
import React from 'react'
import styled from 'styled-components'

import { useHapticFeedback } from '@blade/ui-kit'
import { settingScreenModeAtom } from '@root/features/settings/settings-screen'
import { ChevronLeftIcon, Dialog, Gear2Icon } from '@root/shared/ui-kit'

type SettingsModalHeaderProps = {
  title: React.ReactNode
  onBack?: () => void
}

export const SettingsModalHeader: React.FC<SettingsModalHeaderProps> = ({
  title,
  onBack,
}) => {
  const [screenMode] = useAtom(settingScreenModeAtom)
  const haptics = useHapticFeedback()

  const renderIcon = () => {
    if (screenMode === 'single-policy-screen') {
      return <DummyIcon />
    }

    if (onBack) {
      return (
        <Icon
          onClick={() => {
            haptics.impactOccurred('light')
            onBack()
          }}
        >
          <ChevronLeftIcon size={16} />
        </Icon>
      )
    }

    return <Gear2Icon size={20} color="var(--background-10)" />
  }

  return (
    <Root>
      <Title>
        {renderIcon()}
        {title}
      </Title>
    </Root>
  )
}

const Root = styled(Dialog.Header.Functional)`
  background: var(--background-2);

  display: grid;
  align-items: center;
  grid-template-columns: 1fr auto;

  height: 40px;
  gap: 8px;

  padding-inline: 14px;
`

const Title = styled.h2`
  color: var(--white);

  font-size: 14px;
  font-weight: 600;
  line-height: 20px;

  align-items: center;
  justify-content: center;
  display: grid;
  grid-template-columns: auto 1fr;

  gap: 6px;
`

const Icon = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  color: var(--text-10);
  &:hover {
    color: var(--text-11);
  }

  transition: color 0.2s ease-in-out;
`

const DummyIcon = styled.span`
  width: 20px;
  height: 20px;
`
